<div class="modern-carousel-wrapper">
  <div class="carousel-header">
    <h2 class="carousel-main-title">Sistema HCM</h2>
    <p class="carousel-subtitle">Optimización estratégica de procesos administrativos y talento</p>
  </div>

  <div class="carousel-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

    <div class="carousel-track" [class.paused]="isPaused()">
      @for (card of infiniteCards; track $index) {
      <div class="module-card group" [attr.data-color]="card.theme">
        
        <!-- Premium Visual Accents -->
        <div class="card-glow" [ngClass]="'bg-' + card.theme"></div>
        <div class="card-glare"></div>
        
        <!-- Icon Section - Centered -->
        <div class="icon-section">
          <div class="icon-master-container">
             <div class="icon-ambient-shadow" [ngClass]="'bg-' + card.theme"></div>
             <div class="icon-platform" [ngClass]="'bg-' + card.theme">
                <img [src]="card.icon" [alt]="card.title" class="module-icon-img" onerror="this.src='assets/images/svgs/icon-user-male.svg'">
             </div>
          </div>
        </div>

        <!-- Content Section - Centered -->
        <div class="text-section">
          <h3 class="card-title-main">{{ card.value }}</h3>
          <p class="card-desc-sub">{{ card.description }}</p>
        </div>

        <!-- Decorative Footer Accent -->
        <div class="card-footer-accent" [ngClass]="'bg-' + card.theme"></div>
      </div>
      }
    </div>

  </div>
</div>